import { FrontierRequest, FrontierSummary, PremiumRequest } from '../../../domain/frontier.domain';

export namespace FrontierAction {
    export class Cleanup {
        static readonly type = 'FrontierAction.Cleanup';
    }

    export class GetOne {
        static readonly type = 'FrontierAction.GetOne';

        constructor(public id: number) {
        }
    }

    export class Create {
        static readonly type = 'FrontierAction.Create';

        constructor(public request: FrontierRequest) {
        }
    }

    export class Update {
        static readonly type = 'FrontierAction.Update';

        constructor(public request: FrontierRequest) {
        }
    }

    export class Issue {
        static readonly type = 'FrontierAction.Issue';

        constructor(public offerId: number, public request: FrontierSummary) {
        }
    }
}
